import React, { useEffect, useState } from "react";
import AdminHeading from "../Heading/AdminHeading";
import AdminBreadCrump from "../Heading/AdminBreadCrump";
import "../../PagesStyles/AdminMasters.css";
import { TbCircleNumber1 } from "react-icons/tb";
import { a18, a35, a7 } from "../../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { RiListUnordered, RiPlayListAddLine } from "react-icons/ri";
import AlertMessage from "../../../Other Functions/AlertMessage";

export default function AdminAddCategory() {
  const [active, setActive] = useState("List");
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageToShow, setMessageToShow] = useState("");
  const [loading, setLoading] = useState(false);

  const [allCategories, setAllCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    name: "",
    slug: "",
    label: "",
    material: "",
    parentsCategory: "",
    description: "",
    entryByStaffId: "",
  });
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  let Entryby_Staff_id = parseInt(adminLoggedIn);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const fetchAllCategory = async () => {
    try {
      const response = await fetch(a18);
      const data = await response.json();
      setAllCategories(data.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategory();
  }, []);
  console.log(allCategories);
  const [editingId, setEditingId] = useState(null);
  const [editedData, setEditedData] = useState({});

  const handleEditClick = (id) => {
    setEditingId(id);
    // Find the item with the selected ID and set its data in the state
    const selectedItem = allCategories.find((x) => x.id === id);
    setEditedData(selectedItem);
  };

  const handleSaveClick = () => {
    handleSubmit();
    // Save the edited data to your state or send it to an API
    console.log("Edited Data:", editedData);
    setEditingId(null); // Exit editing mode
  };
  const handleSubmit = async () => {
    try {
      const response = await fetch(a35, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editedData),
      });
      const data = await response.json();

      console.log(data, "updated");
      if (data.message) {
        // alert(data.message);
        setMessageType("error");
        setMessageToShow(data.message);
        setShowError(true);
      } else {
        setMessageType("success");
        setMessageToShow("Updated successfully");
        setShowError(true);
      }
      fetchAllCategory();
    } catch (error) {
      console.error(error);
      alert(error);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setEditedData({ ...editedData, [name]: value });
  };

  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setNewCategory({ ...newCategory, [name]: value });
  };
  const addNewCategory = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = {
      Name: newCategory.name,
      Slug: newCategory.slug,
      Label: newCategory.label,
      ParentsCategory: newCategory.parentsCategory,
      Description: newCategory.description,

      Entryby_Staff_id: Entryby_Staff_id,
    };
    console.log(formData, "formData");
    console.log(formData, "formData");
    console.log(formData, "formData");
    try {
      const response = await fetch(a7, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      fetchAllCategory();
      setActive("List");
      setNewCategory({
        name: "",
        slug: "",
        label: "",
        parentsCategory: "",
        description: "",
      });
      if (data.message) {
        // alert(data.message);
        setMessageType("error");
        setMessageToShow(data.message);
        setShowError(true);
        setActive("AddNew");
      } else {
        setMessageType("success");
        setMessageToShow("Category Added Successfully");
        setShowError(true);
      }
      setLoading(false);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);
  return (
    <div>
      <AdminHeading />
      <div className="adminMainBodyBox">
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={"Add Category"}
          companyName={"Loyalstring"}
          module={"Masters"}
          page={"Category"}
        />
        <div className="adminAddCategoryMainBox">
          <div className="adminAddCategoryInnerBox">
            <div className="adminAddCategoryInnerBoxTitlesBox">
              <div
                onClick={() => {
                  setActive("List");
                }}
                className={
                  active === "List"
                    ? "adminAddCategoryInnerBoxTitle"
                    : "adminAddCategoryInnerBoxTitle activeCategoryTitle"
                }
              >
                <div
                  className={
                    active === "List"
                      ? "adminAddCategoryInnerBoxTitleLogo"
                      : "adminAddCategoryInnerBoxTitleLogo activeCategoryLogo"
                  }
                >
                  {/* 01 */}
                  <RiListUnordered />
                </div>
                <p>All Categories</p>
              </div>

              <div
                onClick={() => setActive("AddNew")}
                className={
                  active === "AddNew"
                    ? "adminAddCategoryInnerBoxTitle"
                    : "adminAddCategoryInnerBoxTitle activeCategoryTitle"
                }
              >
                <div
                  className={
                    active === "AddNew"
                      ? "adminAddCategoryInnerBoxTitleLogo"
                      : "adminAddCategoryInnerBoxTitleLogo activeCategoryLogo"
                  }
                >
                  {/* 02 */}
                  <RiPlayListAddLine />
                </div>
                <p>Add Category</p>
              </div>
            </div>
            <div
              className={
                active === "List" ? "adminCategoryListMainBox" : "none"
              }
            >
              <table>
                <thead>
                  <tr>
                    <th>Edit</th>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Slug</th>
                    <th>Label</th>
                    <th>Parent Category</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {allCategories.map((x) => (
                    <tr key={x.id}>
                      <td>
                        {editingId === x.id ? (
                          <button
                            className="adminAddCategorySaveButton"
                            onClick={handleSaveClick}
                          >
                            Save
                          </button>
                        ) : (
                          <button
                            className="adminAddCategoryEditButton"
                            onClick={() => handleEditClick(x.id)}
                          >
                            Edit
                          </button>
                        )}
                      </td>
                      <td>{x.id}</td>
                      <td>
                        {editingId === x.id ? (
                          <input
                            type="text"
                            name="name"
                            value={editedData.name || ""}
                            onChange={handleInputChange}
                          />
                        ) : (
                          x.name
                        )}
                      </td>
                      <td>
                        {editingId === x.id ? (
                          <input
                            type="text"
                            name="slug"
                            value={editedData.slug || ""}
                            onChange={handleInputChange}
                          />
                        ) : (
                          x.slug
                        )}
                      </td>
                      <td>
                        {editingId === x.id ? (
                          <input
                            type="text"
                            name="label"
                            value={(editedData.label || "").toUpperCase()} // Convert to uppercase
                            onChange={handleInputChange}
                            maxLength="4"
                            onInput={(e) => {
                              let inputValue = e.target.value
                                .toUpperCase()
                                .replace(/[^A-Z0-9]/g, ""); // Convert to uppercase and remove characters other than A-Z and 0-9

                              // Ensure the input doesn't end with a number (note: this logic seems contradictory to allowing A-Z0-9, so you might reconsider this part based on your actual needs)
                              if (/^\D+$/.test(inputValue)) {
                                // Ensure the length is not more than 4 characters
                                if (inputValue.length <= 4) {
                                  e.target.value = inputValue;
                                } else {
                                  // If it exceeds 4 characters, truncate it
                                  e.target.value = inputValue.slice(0, 4);
                                }
                              } else {
                                // If it ends with a number, this block might not be needed since you're allowing numbers; consider removing this else block.
                                e.target.value = inputValue.slice(0, -1);
                              }

                              handleInputChange(e);
                            }}
                          />
                        ) : (
                          x.label
                        )}
                      </td>

                      <td>
                        {editingId === x.id ? (
                          <select
                            name="parentsCategory"
                            value={editedData.parentsCategory || ""}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Select an option</option>
                            <option value="Metal">Metal</option>
                            <option value="Non-Metal">Non-Metal</option>
                          </select>
                        ) : (
                          x.parentsCategory
                        )}
                      </td>
                      <td>
                        {editingId === x.id ? (
                          <input
                            type="text"
                            name="description"
                            value={editedData.description || ""}
                            onChange={handleInputChange}
                          />
                        ) : (
                          x.description
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div
              className={
                active !== "List" ? "adminCategoryAddCategoryMainBox" : "none"
              }
            >
              <p>Add New Category</p>
              <form onSubmit={addNewCategory}>
                <div className="adminCategoryAddCategoryInnerBox">
                  <label>
                    Name <sup> *</sup>
                  </label>
                  <input
                    name="name"
                    value={newCategory.name}
                    onChange={handleNewCategoryChange}
                    type="text"
                    required="required"
                  />
                  <label>Slug</label>
                  <input
                    name="slug"
                    value={newCategory.slug}
                    onChange={handleNewCategoryChange}
                    type="text"
                  />
                  <label>
                    Label <sup> *</sup>
                  </label>
                  <input
                    name="label"
                    value={newCategory.label}
                    onChange={handleNewCategoryChange}
                    type="text"
                    required="required"
                    placeholder="Only Capitals"
                    maxLength="4" // HTML attribute to restrict input length
                    onInput={(e) => {
                      let inputValue = e.target.value
                        .toUpperCase() // Convert to uppercase
                        .replace(/[^A-Z0-9]/g, ""); // Remove characters other than A-Z and 0-9

                      e.target.value = inputValue.substring(0, 4); // Further ensure it does not exceed 4 characters
                    }}
                  />

                  <label>
                    Parent Category <sup> *</sup>
                  </label>
                  <select
                    name="parentsCategory"
                    required="required"
                    value={newCategory.parentsCategory}
                    onChange={handleNewCategoryChange}
                    type="text"
                  >
                    <option value="">Select an option</option>
                    <option value="Metal">Metal</option>
                    <option value="Non-Metal">Non-Metal</option>
                  </select>
                  <label>Description</label>
                  <input
                    name="description"
                    value={newCategory.description}
                    onChange={handleNewCategoryChange}
                    type="text"
                  />
                  {!loading ? <button type="submit">Submit</button> : null}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
